<template>
  <div>
    <form @submit.stop.prevent="setCompanyBaseData" class="text-left">
      <h5 v-translate>Base Information</h5>
      <b-form-row>
        <b-col cols="12">
          <static-map v-if="defaultShippingFields.lat" :markers="defaultShippingFields.markers" :size="[500, 250]" class="card-img-top mb-3" />
        </b-col>
        <b-form-group class="col-12">
          <label for="from_extra" v-translate>Street and number</label>
          <address-autocomplete ref="addressAutocomplete" @selected="selectedItem" :min-character="6" static-items required v-if="!defaultShippingFields.googlePlaceString" />
          <p v-else>
            {{ defaultShippingFields.googlePlaceString }} <b-badge variant="danger" href="#" @click.prevent="defaultShippingFields.googlePlaceString = null; defaultShippingFields.placeId = null; defaultShippingFields.lat = null; defaultShippingFields.lng = null">×</b-badge>
          </p>
        </b-form-group>
        <b-form-group class="col-12">
          <label for="contact-name" v-translate>Operations Contact Name</label>
          <b-form-input id="contact-name" v-model="defaultShippingFields.contact.firstName" required />
        </b-form-group>
        <b-form-group class="col-12">
          <label for="contact-email" v-translate>Operations Contact Email</label>
          <b-form-input id="contact-email" type="email" v-model="defaultShippingFields.contact.email" />
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-col cols="12" class="text-center form-actions">
          <b-form-group>
            <b-button size="md" :variant="baseHasChanges ? 'secondary' : 'dark'" :disabled="!baseHasChanges" type="submit">
              <b-spinner small v-if="updating"></b-spinner>
              <translate>Set Base Information</translate>
            </b-button>
          </b-form-group>
        </b-col>
      </b-form-row>
    </form>
  </div>
</template>

<script>
import AddressesMixin from '@/mixins/address.mixin'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import StaticMap from '@/components/Maps/MapboxStaticMap'

export default {
  name: 'SetBaseForm',
  components: {
    AddressAutocomplete,
    StaticMap
  },
  data() {
    return {
      baseLocation: null,
      hash: null,
      updating: false,
      defaultShippingFields: {
        placeId: null,
        googlePlaceString: null,
        lat: null,
        lng: null,
        street: '',
        number: '',
        floor: '',
        apartment: '',
        city: '',
        state: '',
        postalCode: '',
        country: 'ARG',
        instructions: '',
        contact: {
          firstName: '',
          lastName: '',
          email: '',
          phone: ''
        },
        message: '',
        markers: []
      }
    }
  },
  computed: {
    baseHasChanges() {
      return JSON.stringify(this.defaultShippingFields) !== this.hash
    }
  },
  mixins: [
    AddressesMixin
  ],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.profile.company.default_shipping_fields) {
        this.defaultShippingFields.contact.firstName = this.profile.company.contact_name
        this.defaultShippingFields.contact.email = this.profile.company.email
        this.defaultShippingFields.contact.phone = this.profile.company.phone
      } else {
        this.defaultShippingFields = this.defaultShippingFields.lat ? this.defaultShippingFields : this.profile.company.default_shipping_fields
        if (this.defaultShippingFields.lat) {
          this.defaultShippingFields.markers = []
          this.defaultShippingFields.markers.push({
            id: '0',
            lat: this.defaultShippingFields.lat,
            lng: this.defaultShippingFields.lng,
            icon: 'pin-s+090'
          })
          this.baseLocation = this.defaultShippingFields.markers[0]
          // this.baseMarker()
        }
      }
      this.hash = JSON.stringify({...this.defaultShippingFields})
    },
    async selectedItem(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.defaultShippingFields.placeId = this.theCheckedAddress.id
          this.defaultShippingFields.googlePlaceString = this.theCheckedAddress.formatted_address
          this.defaultShippingFields.lat = this.theCheckedAddress.lat
          this.defaultShippingFields.lng = this.theCheckedAddress.lng
          this.defaultShippingFields.markers = []
          this.defaultShippingFields.markers.push({
            id: '0',
            lat: this.defaultShippingFields.lat,
            lng: this.defaultShippingFields.lng
          })
        }
        this.theCheckedAddress = {}
      })
      // this.defaultShippingFields.googlePlaceString = this.formattedDisplay(item)
    },
    setCompanyBaseData() {
      this.updating = true
      this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id, {default_shipping_fields: this.defaultShippingFields})
        .then(response => {
          this.$store.dispatch('fetchProfile')
            .then(response => {
              this.init()
              this.updating = false
              this.makeToast(this.$gettext('Success'), this.$gettext('The Company Base has been updated! 👍'), 'success', false, 4000)
            })
        })
    }
  }
}
</script>
